import { SvgIcon, SvgIconProps } from "@mui/material";

export default function DownloadFileIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 29">
      <path
        fillRule="nonzero"
        d="M31.3 13.793a1.6 1.6 0 0 1 1.601 1.6v6.693a6.845 6.845 0 0 1-6.838 6.837H7.545a6.845 6.845 0 0 1-6.837-6.837v-6.692a1.6 1.6 0 1 1 3.201 0v6.692a3.641 3.641 0 0 0 3.636 3.637h18.518a3.642 3.642 0 0 0 3.638-3.637v-6.692a1.6 1.6 0 0 1 1.6-1.6zM19.225.05c.98 0 1.774.795 1.774 1.776v9.665h3.258a1.334 1.334 0 0 1 .942 2.275l-7.453 7.454c-.521.52-1.364.52-1.886 0l-7.453-7.454a1.332 1.332 0 0 1 .942-2.276h3.257V1.826c0-.981.795-1.776 1.775-1.776z"
      />
    </SvgIcon>
  );
}
